module.exports = __webpack_public_path__ + "img/arrow_up.f3198dfe.svg";